import { kbitToBit } from './kbit-to-bit.fn';

export function mbitToBit(mbits: number) {
  return kbitToBit(mbits * 1000);
}
